import { useMutation } from "react-query"
import api from "../client"
import { AuthSetPasswordPayload } from "../types/auth"

const postData = async (payload: AuthSetPasswordPayload) => {
    try {

        const { data } = await api.post(
            "/users/set-password",
            payload
        )
        return data
    } catch (err: any) {
        return err.response.data
    }
}

export const useAuthSetPassword = () => {
    return useMutation((payload: AuthSetPasswordPayload) => {
        return postData(payload)
    })
}
